export default __webpack_public_path__ + "static/media/logo-sigma.b746c179.svg";